import Http from '@/support/http';
import S from '@/support/string';

export default {
	state: {
		list: [],
		selected: {}
	},
	mutations: {
		SET_CLASS_LIST(state, payload) {
			state.list = payload;
		},
		SET_SELECTED_CLASS(state, payload) {
			state.selected = payload;
		}
	},
	getters: {
		getClass: (state) => state.selected
	},
	actions: {
		setSelectedClass(context, payload) {
			context.commit('SET_SELECTED_CLASS', payload);
		},
		getClassByUser(context, payload) {

			if (payload) {
				const queryString = '?' + S.toQueryStringParameters(payload);
				const scope = payload.scope ? payload.scope : 'global';

				return Http.get(`v1/school-class/user/${ payload.userId }${ queryString }`).then((response) => {

					if (scope === 'global') {
						context.commit('SET_CLASS_LIST', response.data.object);
					}

					return response;

				});

			}

		}
	}
};



// WEBPACK FOOTER //
// ./sources/domains/school/class-list/store.js